import config from '../api/config'
import {t} from "../utils/filters";
import GalleryItems from "../../vue/Gallery/GalleryItems.vue";
import Gallery from "../../vue/Gallery/Gallery.vue";
import { acceptHot } from '../utils/hot';
import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);
Vue.filter('t', t);
const main = async() => {
    const router = new VueRouter({
        base: window.basePath,
        mode: "history",
        routes: [
            { path: '/', name: 'index', component: GalleryItems, props: true },
        ]
    });

    const app = new Vue({
        router,
        components: {
            'gallery': Gallery,
        },
        data: {
            filterProducts: window.filterProducts,
            filterCategories: window.filterCategories,
        },
        watch: {
            '$route'(to, from) {
                if (from.name === to.name) {
                    this.$router.replace({
                        query: {
                            ...from.query,
                            ...to.query
                        },
                        hash: to.hash
                    })
                }
            }
        }
    }).$mount('#gallery');
};

// Execute async function
main().then(() => {
});

acceptHot(import.meta, typeof module !== 'undefined' ? module : undefined);
